module.exports = __webpack_public_path__ + "static/f45ea37a.myproductguide.gif";